import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

// Define Props Interface
interface LoadingProps {
  renderTitle: () => string;
}

// Functional Component with Default Value
export const Loading: React.FC<LoadingProps> = ({renderTitle = () => ''}) => {
  return (
    <View>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {renderTitle()}
        </Text>
      </Gutter>
      <View style={styles.order}>
        <View style={styles.orderLine1}>
          <View style={styles.orderDate}>
            <LoadingBox style={styles.loadingBoxOrderDate} />
            <LoadingBox style={styles.loadingBoxOrderNumber} />
          </View>
          <View style={styles.orderAmount}>
            <LoadingBox style={styles.loadingBoxOrderTotal} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default withTranslation('reportCardContent.orderHistoryReport')(Loading);
